











import { defineComponent, ref, onMounted, PropType } from '@nuxtjs/composition-api';
import type { Product } from '~/modules/catalog/product/types';
import useRelatedProducts from '~/modules/catalog/product/composables/useRelatedProducts';
import ProductsCarousel from '~/modules/catalog/product/components/ProductsCarousel.vue';
import { usePageStore } from '~/stores/page';
import { useCustomRelatedProducts } from '~/modules/catalog/product/composables/useCustomRelatedProducts/useCustomRelatedProducts';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  name: 'RelatedProducts',
  components: {
    ProductsCarousel,
    SkeletonLoader,
  },
  props: {
    /* routerDataRes: {
      type: Object,
      default: {}
    }, */
    products: {
      type: Array as PropType<Product[]>,
      required: false,
      default: () => [],
    },
    loading: Boolean,
  },
  setup() {
    /* const { routeData } = usePageStore();
    const { relatedProducts, loading, load } = useCustomRelatedProducts();
    const { search } = useRelatedProducts();
    const products = ref([]); */

    /* onMounted(async () => {
      const baseSearchQuery = {
        filter: {
          sku: {
            eq: (routeData != null && routeData.sku)? routeData.sku : routerDataRes.sku,
          },
        },
      };
      await load(baseSearchQuery);
      products.value = relatedProducts.value;
      //products.value = await search(baseSearchQuery);
    }); */

    // Do not return props to avoid duplicate binding warnings.
    // The template can access props directly: products, loading.
    return {
    };
  },
});
